module.exports = __webpack_public_path__ + "static/media/star.dd4273f4.svg";